module.exports = "https://static.wmbcdn.com/uniweb/images/9d104c861c9ffebf18381db084979c21.svg";